import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoursesState } from '../reducers/courses.reducer';
import { COURSES_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<CoursesState>(COURSES_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: CoursesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: CoursesState) => state.loading);
export const selectCourses = createSelector(selectState, (state: CoursesState) => state.courses);
export const selectTotal = createSelector(selectState, (state: CoursesState) => state.total);
export const selectPage = createSelector(selectState, (state: CoursesState) => state.page);
export const selectLimit = createSelector(selectState, (state: CoursesState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: CoursesState) => state.lastParams);
